import axios from "axios";
import { apis, serverCall } from "../../utils/api/constant";
import { fetchDataFailure, fetchDataRequest, fetchDataSuccess } from "./action";

// Thunk action creator
export const fetchData = (userName, password,navigate) => {
    return async (dispatch, getState) => {
      // dispatch(fetchDataRequest());
      try {
        // const response = await axios.get('https://api.example.com/data');
        let response = await serverCall(apis.USER_LOGIN, "POST", {"apiID": 0,"userName":userName,"password":password});
        if(response.success){
          setTimeout(() => {
           dispatch(fetchDataSuccess(response.data));
           console.log(response.data,"response.data")
           localStorage.setItem("USER_DETAILS",JSON.stringify(response.data) )
          navigate("/Dashboard",{ replace: true });
         }, 1000);
        }else{
          dispatch(fetchDataFailure(response?.data?.ERROR_MSG));
        }
        // dispatch(fetchDataSuccess(true));
      } catch (error) {
         dispatch(fetchDataFailure(error.message));
        // dispatch(fetchDataSuccess(true));
      }
    };
  };